import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const depositSchema = z.object({
  /** Order ID, e.g. `"1"` */
  orderId: z.string(),
  //   "tradeId": "1",
  /** TX ID, e.g. `"1"` */
  tradeId: z.string(),
  /** Token name, e.g. `"USDT"` */
  coin: z.string(),
  /** Type, e.g. `"deposit"` */
  type: z.string(),
  //   "size": "10.00000000",
  /** Quantity, e.g. `"10.00000000"` */
  size: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Withdrawal status */
  status: z.union([
    z.literal('pending'),
    z.literal('fail'),
    z.literal('success'),
  ]),
  /** Coin Replenishment Initiators, e.g. `"0x52xxx"` */
  fromAddress: z.string().nullable(),
  /** Coin Receiver, e.g. `"0x51xxx"` */
  toAddress: z.string(),
  /** Ticin network, e.g. `"erc20"` */
  chain: z.string(),
  dest: z.union([
    z.literal('on_chain'),
    z.literal('internal'),
    z.literal('fast'),
  ]),
  /** Creation time, e.g. `"1653290769222"` */
  cTime: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
  /** Edit time, e.g. `"1653290769222"` */
  uTime: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
})

export type Deposit = z.infer<typeof depositSchema>
